<template>
  <nav class="side-navbar box-scroll sidebar-scroll">
    <!-- Begin Main Navigation -->
    <ul class="list-unstyled">
      <li>
        <router-link to="/dashboard/users">
          <i class="la la-spinner"></i>
          <span>کاربران</span>
        </router-link>
      </li>
      <li>
        <router-link to="/dashboard/shop">
          <i class="la la-spinner"></i>
          <span>فروشگاه</span>
        </router-link>
      </li>
      <li>
        <router-link to="/dashboard/leagues">
          <i class="la la-spinner"></i>
          <span>لیگ</span>
        </router-link>
      </li>
      <li>
        <router-link to="/dashboard/finantial">
          <i class="la la-font"></i>
          <span>گزارشات مالی</span>
        </router-link>
      </li>
    </ul>

    <!-- <span class="heading">لیگ</span> -->
    <ul class="list-unstyled">
      <li>
        <a href="#dropdown-app" aria-expanded="false" data-toggle="collapse">
          <i class="la la-puzzle-piece"></i>
          <span>تنظیمات بازی انلاین</span>
        </a>
        <ul id="dropdown-app" class="collapse list-unstyled pt-0">
          <li>
            <router-link to="/dashboard/grounds">زمین ها</router-link>
          </li>
          <li>
            <router-link to="/dashboard/skins">مهره ها</router-link>
          </li>
          <li>
            <router-link to="/dashboard/formations">ترکیب ها</router-link>
          </li>
          <li>
            <router-link to="/dashboard/boots">کفش ها</router-link>
          </li>
          <li>
            <router-link to="/dashboard/chats">ایموجی ها</router-link>
          </li>
          <li>
            <a href="/dashboard/achievemnt">اچیومنت ها</a>
          </li>
          <li>
            <router-link to="/dashboard/avatars">آولتار ها</router-link>
          </li>
        </ul>
      </li>

      <li>
        <a href="#dropdown-user-perms" aria-expanded="false" data-toggle="collapse">
          <i class="la la-font"></i>
          <span>دسترسی ها</span>
        </a>
        <ul id="dropdown-user-perms" class="collapse list-unstyled pt-0">
          <li>
            <router-link to="/dashboard/UserGroups">گروه ها</router-link>
          </li>
          <li>
            <router-link to="/dashboard/UserRules">قوانین</router-link>
          </li>
        </ul>
      </li>
      <li>
        <a href="#dropdown-forms" aria-expanded="false" data-toggle="collapse">
          <i class="la la-list-alt"></i>
          <span>تنظیمات</span>
        </a>
        <ul id="dropdown-forms" class="collapse list-unstyled pt-0">
          <li>
            <router-link to="/dashboard/splashes">اسپلش</router-link>
          </li>
        </ul>
        <ul id="dropdown-forms" class="collapse list-unstyled pt-0">
          <li>
            <router-link to="/dashboard/fake">fake usernames</router-link>
          </li>
        </ul>
        <ul id="dropdown-forms" class="collapse list-unstyled pt-0">
          <li>
            <router-link to="/dashboard/max">max بازی</router-link>
          </li>
        </ul>
        <ul id="dropdown-forms" class="collapse list-unstyled pt-0">
          <li>
            <router-link to="/dashboard/adSettings">تنظیمات تبلیغ</router-link>
          </li>
        </ul>
        <ul id="dropdown-forms" class="collapse list-unstyled pt-0">
          <li>
            <router-link to="/dashboard/advertisements">مدیریت تبلیغات</router-link>
          </li>
        </ul>
        <ul id="dropdown-forms" class="collapse list-unstyled pt-0">
          <li>
            <router-link to="/dashboard/lisenceSettings">تنظیمات اشتراک</router-link>
          </li>
        </ul>
        <ul id="dropdown-forms" class="collapse list-unstyled pt-0">
          <li>
            <router-link to="/dashboard/purchaseSetting">تنظیمات پرداخت</router-link>
          </li>
        </ul>
        <ul id="dropdown-forms" class="collapse list-unstyled pt-0">
          <li>
            <router-link to="/dashboard/PaymentSegments">دسته بندی های پرداخت</router-link>
          </li>
        </ul>
        <ul id="dropdown-forms" class="collapse list-unstyled pt-0">
          <li>
            <router-link to="/dashboard/pservices">درگاه های پرداخت</router-link>
          </li>
        </ul>
        <ul id="dropdown-forms" class="collapse list-unstyled pt-0">
          <li>
            <router-link to="/dashboard/licenses">اشتراک ها</router-link>
          </li>
        </ul>

        <ul id="dropdown-forms" class="collapse list-unstyled pt-0">
          <li>
            <router-link to="/dashboard/baners">بنر ها</router-link>
          </li>
        </ul>
        <ul id="dropdown-forms" class="collapse list-unstyled pt-0">
          <li>
            <router-link to="/dashboard/UserHints">راهنمایی ها</router-link>
          </li>
        </ul>
      </li>
      <li>
        <router-link to="/dashboard/publicmessage">پیام های عمومی</router-link>
      </li>
      <li>
        <a href="components-widgets.html">
          <i class="la la-spinner"></i>
          <span>پروفایل</span>
        </a>
      </li>
      <li>
        <a href="#dropdown-gifts" aria-expanded="false" data-toggle="collapse">
          <i class="la la-list-alt"></i>
          <span>هدیه</span>
        </a>
        <ul id="dropdown-gifts" class="collapse list-unstyled pt-0">
          <li>
            <router-link to="/dashboard/Gifts">بسته های هدیه</router-link>
          </li>
          <li>
            <router-link to="/dashboard/daily">هدیه روزانه</router-link>
          </li>
          <li>
            <router-link to="/dashboard/spinner">اسپینر</router-link>
          </li>
        </ul>
      </li>
      <li>
        <a @click="logout">
          <i class="la la-spinner"></i>
          <span>خروج</span>
        </a>
      </li>
    </ul>
    <!-- End Main Navigation -->
  </nav>
</template>

<script>
export default {
  name: 'SideBarMain',
  methods: {
    async logout() {
      try {
        await window.axios.get('/api/v1/admin/logout');
        this.$router.replace('/');
      } catch (err) {
        this.$router.replace('/');
      }
    },
  },
};
</script>
